import { ReactNode, useState } from "react";

type useModalProps = {
  initValue?: boolean;
  callBackClose?: () => void;
};
export const useModal = (props?: useModalProps) => {
  const [openModal, setOpenModal] = useState<boolean>(
    props?.initValue ?? false,
  );

  const close = () => {
    if (props?.callBackClose) props.callBackClose();
    setOpenModal(false);
  };

  const open = () => {
    setOpenModal(true);
  };
  return {
    openModal,
    setOpenModal,
    close,
    open,
  };
};

export function ModalProvider({
  input,
  children,
}: {
  input?: useModalProps;
  children: (props: ReturnType<typeof useModal>) => ReactNode;
}) {
  const r = useModal(input);

  return <>{children(r)}</>;
}
